<div class="root">
    <news-puff class="root__item" *ngFor="let item of newsItems$ | async" [item]="item"></news-puff>
</div>
